import { NPS_LOOKER_DATA_URL } from 'components/NpsTransitionModal/constants'
import React from 'react'
import { Redirect } from 'react-router-dom'

// The TUTD (thumbs-up/down) presentation lives at its own /order_feedback
// route. This legacy route now unconditionally hands its viewers over to the
// InsightsLab NPS labs -- the pre-TUTD Looker page it used to serve is gone.
const NpsReport = () => <Redirect to={NPS_LOOKER_DATA_URL} />

export default NpsReport
